import LayoutWrapper from "../../LayoutWrapper";
import MarketplacePartnerScreen from "../../MarketplacePartnerScreen";

export default function PartnersList() {
    return (
        <LayoutWrapper model="marketplace" renderOpsBar={false}>
            <MarketplacePartnerScreen allowDownloadCsvLink={true} allowLayoutSelection={true} enableDomainSelection={false} />
        </LayoutWrapper>
    )
}